'use strict';

angular.module('portal.login')
    .controller('CreateAccount', ['$scope', '$state', '$stateParams', '$rootScope', '$window', 'EntityEnterpriseFields', 'Users', 'Enterprise', 'IntegrationMethods', 'Countries', 'EnterpriseLoginCriteria', 'Authentication', 'Account', function ($scope, $state, $stateParams, $rootScope, $window, EntityEnterpriseFields, Users, Enterprise, IntegrationMethods, Countries, EnterpriseLoginCriteria, Authentication, Account) {

        $scope.loading = true;
        $scope.saving = false;
        $scope.lookup = false;
        $scope.showEliteLookup = false;
        $scope.looking_up = false;
        $scope.promises = [];
        $scope.USDefault = '';
        //Autofilling the existing user info when coming from SSO
        $scope.autofill = $stateParams.autofill == "true" || false;

        // Finds US's id to default to US
        Countries.get().then(function (countries) {
            angular.forEach(countries, function (c) {
                if (c.name == 'United States') {
                    $scope.USDefault = c.id;
                }
            });
        });

        $scope.entity_categories = {

        };
        $scope.parameters = {
            enterpriseID: $rootScope.enterpriseID,
            locationIntegrationId: $rootScope.locationIntegration.id
        };
        $scope.locationIntegrationEnabled = $rootScope.locationIntegration.enable;
        $scope.selectedLocation = null;
        $scope.fieldsByCode = {};
        $scope.failedMessages = [];

        $scope.user_public_addresses = $rootScope.enterprise.settings.user_public_addresses;

        $scope.eliteSignature = {
            username: null,
            pass: null
        }
       
        $scope.user = {};
        if ($scope.autofill) {
            //Fill in existing values so the SSO user can "finish" creating their account.
            //Have to authenticate first because coming from net won't have portalAuthorizationData set.
            $scope.failedMessages = ["Please enter in any missing information and finish creating your account."];
            Authentication.authenticate(true).then(function (authData) {
                if (authData) {
                    Account.get({ portal: true }).then(function (account) {
                        if (account) {
                            $rootScope.userAccount = account;
                            $rootScope.$broadcast('AuthenticationFromSSO:finish');

                            Users.getByID($rootScope.userAccount.id, false, true).then(function (user) {
                                //Users created through SSO won't have much info, so just filling in most of the core record values
                                if (!user.public_address) { user.public_address = {} }
                                if (!user.primary_address) { user.primary_address = {} }
                                if (user.email) { user.verify_email = user.email }
                                $scope.user = user;
                            });
                        }
                        else {
                            // Get a new, empty user
                            Users.getNewUser().then(function (user) { $scope.user = user; });
                        }
                    });
                }
                else {
                    // Get a new, empty user
                    Users.getNewUser().then(function (user) { $scope.user = user; });
                }
            });
        }
        else {
            // Get a new, empty user
            Users.getNewUser().then(function (user) { $scope.user = user; });
        }

        $scope.enterprise = {};
        if ($rootScope.enterprise != null) {
            $scope.enterprise = $rootScope.enterprise;
            if ($scope.enterprise.ssn_generation_type == "Masked") {
                $scope.user.ssn_dec = "•••-••-";
                $scope.user.verify_ssn = "•••-••-";
            }
        } else {
            Enterprise.getLess({ enterpriseID: $rootScope.enterpriseID, isPortal: true }).then(function (result) {
                $scope.enterprise = result;
                if ($scope.enterprise.ssn_generation_type == "Masked") {
                    $scope.user.ssn_dec = "•••-••-";
                    $scope.user.verify_ssn = "•••-••-";
                }
            });
        }

        //recaptcha vars
        $scope.recaptchaMessage = ($scope.enterprise.recaptcha_site_key_v3 == null && $scope.enterprise.recaptcha_enabled) ? "There was an issue loading recaptcha, please try again or contact system administrator." : ""; //message to display

        $scope.isSsnMasked = function () {
            return $scope.enterprise.ssn_generation_type == "Masked";

        }

        // See if the Elite Lookup button should show
        IntegrationMethods.get({ forEliteLookup: true, enterpriseID: $rootScope.enterpriseID }).then(function (results) {
            if (results != null && results.length) {
                $scope.showEliteLookup = true;
            }
        });


        // Get the entity fields
        EntityEnterpriseFields.get({ category: "CreateAccount", enterpriseID: $rootScope.enterpriseID }).then(function (results) {
            if (results != null) {
                $scope.entity_categories = results;
                angular.forEach($scope.entity_categories, function (c) {
                    angular.forEach(c.fields, function (field) {
                        if (field.json != null && $scope.user[field.json] === undefined) {
                            $scope.user[field.json] = null;
                        }
                        // Don't include the user_name field on the page if it's supposed to be auto-generated
                        if (field.alias == 'user_name' && $scope.enterprise.user_name_generation_type != "None") {
                            field.visible = false;
                        }
                        if (field.alias == 'address') {
                            field.label == null ? $scope.addressLabel = field.name : $scope.addressLabel = field.label;
                        }
                        if (field.alias == 'public_address') {
                            field.label == null ? $scope.publicAddressLabel = field.name : $scope.publicAddressLabel = field.label;
                        }
                        
                        field.autoComplete = "off";
                        switch (field.question_type_code) {
                            case "date":
                            case "phone":
                            case "text":
                                field.autoComplete = fillAutoCompleteForFields(field);
                                break;
                            case "email":
                                field.autoComplete = 'email';
                            case "postal_code":
                            default:
                                break;
                        }
                        $scope.fieldsByCode[field.alias] = field;

                    });
                });
                $scope.global_id = guid();
                $scope.loading = false;
            }
        });

        // Get the Elite Integration Method

        $scope.setupAddress = function (field) {
            var address = {
                country_id: null,
                street_1: null,
                street_2: null,
                postal_code: null,
                municipality: null,
                county: null,
                region_id: null
            };
            // we need to track the two addresses for the "same as primary" functionality
            if (field.alias == 'address' && ($scope.user.primary_address === undefined || $scope.user.primary_address == null)) {
                $scope.user.primary_address = address;
            } else if (field.alias == 'public_address' && ($scope.user.public_address === undefined || $scope.user.public_address == null)) {
                address.same_as_primary = false;
                $scope.user.public_address = address;
            }
        }

        $scope.$watch('user.primary_address', function (newValue, oldValue) {
            if ($scope.user.public_address && $scope.user.public_address.same_as_primary && newValue !== oldValue) {
                $scope.copyAddress($scope.user.public_address, $scope.user.primary_address);
            }
        }, true);
        $scope.$watch('user.public_address.same_as_primary', function (newValue, oldValue) {
            if (newValue !== oldValue && newValue) {
                $scope.copyAddress($scope.user.public_address, $scope.user.primary_address);
            }
        });

        $scope.showAddress = function (field) {
            return ((field.alias == 'address') || (field.alias == 'public_address' && $scope.user_public_addresses && !$scope.user.public_address.same_as_primary));
        }

        $scope.showSameAsAddress = function () {
            return ($scope.fieldsByCode.address !== undefined && $scope.fieldsByCode.public_address !== undefined && $scope.user_public_addresses);
        }

        $scope.copyAddress = function (addr1, addr2) {
            addr1.country_id = addr2.country_id;
            addr1.street_1 = addr2.street_1;
            addr1.street_2 = addr2.street_2;
            addr1.postal_code = addr2.postal_code;
            addr1.municipality = addr2.municipality;
            addr1.county = addr2.county;
            addr1.region_id = addr2.region_id;
        }

        $scope.$watch('user.email', function (newValue, oldValue) {
            if ($scope.user.public_email_same_as_primary && newValue !== oldValue) {
                $scope.user.public_email = $scope.user.email;
            }
        }, true);
        $scope.$watch('user.public_email_same_as_primary', function (newValue, oldValue) {
            if (newValue !== oldValue && newValue) {
                $scope.user.public_email = $scope.user.email;
            }
        });
        $scope.showEmail = function (field) {
            return ((field.alias == 'email') || (field.alias == 'public_email' && !$scope.user.public_email_same_as_primary));
        }

        // ========================== //
        // Elite account import stuff //
        // ========================== //

        $scope.toggleLookup = function () {
            $scope.lookup = !$scope.lookup;
        }

        $scope.getEliteData = function () {
            $scope.failedMessages = [];
            if ($scope.eliteSignature.username == null || $scope.eliteSignature.username == "" || $scope.eliteSignature.pass == null || $scope.eliteSignature.pass == "") {
                $scope.failedMessages = ["Please provide both your username and password"];
            } else {
                $scope.looking_up = true;
                Users.eliteLookup($scope.eliteSignature).then(function (result) {
                    if (result != null) {
                        if (result.error_message != null) {
                            $scope.failedMessages = [result.error_message];
                        } else if (result.global_id != null) {
                            $scope.user = result;
                            $scope.lookup = false;
                        }
                    }
                    $scope.looking_up = false;
                });
            }
        }

        // Save
        $scope.save = function () {
            var failed = false;
            $scope.saving = true;
            $scope.failedMessages = [];
            $scope.validationMessages = [];

            // Check that any "verify" fields check out
            if ($scope.user.ssn_dec !== undefined && $scope.user.ssn_dec != null && $scope.user.ssn_dec.length > 0) {
                if ($scope.fieldsByCode.verify_ssn !== undefined) {
                    if ($scope.fieldsByCode.verify_ssn.validation === undefined || $scope.fieldsByCode.verify_ssn.validation == null) {
                        $scope.fieldsByCode.verify_ssn.validation = {};
                    }
                    if ($scope.user.verify_ssn === undefined || $scope.user.verify_ssn != $scope.user.ssn_dec) {
                        failed = true;
                        $scope.fieldsByCode.verify_ssn.validation.customFunctionFailed = true;
                        $scope.fieldsByCode.verify_ssn.validation.customFunctionMessage = "Social Security Numbers must match!";
                        $scope.validationMessages.push("verify_ssn");
                    } else {
                        $scope.fieldsByCode.verify_ssn.validation.customFunctionFailed = false;
                    }
                }
            }
            if ($scope.user.email !== undefined && $scope.user.email != null && $scope.user.email.length > 0) {
                if ($scope.fieldsByCode.verify_email !== undefined) {
                    if ($scope.fieldsByCode.verify_email.validation === undefined || $scope.fieldsByCode.verify_email.validation == null) {
                        $scope.fieldsByCode.verify_email.validation = {};
                    }
                    if ($scope.user.verify_email === undefined || $scope.user.verify_email != $scope.user.email) {
                        failed = true;
                        $scope.fieldsByCode.verify_email.validation.customFunctionFailed = true;
                        $scope.fieldsByCode.verify_email.validation.customFunctionMessage = "Emails must match!";
                        $scope.validationMessages.push("verify_email");
                    } else {
                        $scope.fieldsByCode.verify_email.validation.customFunctionFailed = false;
                    }
                }
            }
            if ($scope.user.birth_date) {
                if (!$scope.fieldsByCode.birth_date.validation) {
                    $scope.fieldsByCode.birth_date.validation = {};
                }
                var today = new Date();
                var age = today.getFullYear() - $scope.user.birth_date.getFullYear();
                var month = today.getMonth() - $scope.user.birth_date.getMonth();
                if (month < 0 || (month === 0 && today.getDate() < $scope.user.birth_date.getDate())) {
                    age--;
                }
                if (age < 10) {
                    failed = true;
                    $scope.fieldsByCode.birth_date.validation.customFunctionFailed = true;
                    $scope.fieldsByCode.birth_date.validation.customFunctionMessage = "Invalid " + ($scope.fieldsByCode.birth_date.label || $scope.fieldsByCode.birth_date.name);
                    $scope.validationMessages.push("birth_date");
                } else {
                    $scope.fieldsByCode.birth_date.validation.customFunctionFailed = false;
                }
            }
            
            //Validate EMS ID length
            if ($scope.user.National_EMS_ID) {
                if (!$scope.fieldsByCode.National_EMS_ID.validation) {
                    $scope.fieldsByCode.National_EMS_ID.validation = {};
                }
                // Require it to be full length (set in db) and digits only
                if ($scope.user.National_EMS_ID.length != $scope.fieldsByCode.National_EMS_ID.max_length || !(/^\d+$/.test($scope.user.National_EMS_ID))) {
                    failed = true;
                    $scope.fieldsByCode.National_EMS_ID.validation.customFunctionFailed = true;
                    $scope.fieldsByCode.National_EMS_ID.validation.customFunctionMessage = "Invalid " + ($scope.fieldsByCode.National_EMS_ID.label || $scope.fieldsByCode.National_EMS_ID.name);
                    $scope.validationMessages.push("National_EMS_ID");
                }
                else {
                    $scope.fieldsByCode.National_EMS_ID.validation.customFunctionFailed = false;
                }
            }

            // Anti XSS Validation
            for (var code in $scope.fieldsByCode) {
                var field = $scope.fieldsByCode[code];
                var value = $scope.user[field.json];
                // If a text field is filled, validate it
                if (value) {
                    if (field.question_type_code === "text") {
                        // Validate the string
                        if (!$rootScope.isStringSafe(value)) {
                            // Block submission
                            failed = true;
                            // Show error message under field
                            if (!$scope.fieldsByCode[code].validation) {
                                $scope.fieldsByCode[code].validation = {};
                            }
                            $scope.fieldsByCode[code].validation.customFunctionFailed = true;
                            $scope.fieldsByCode[code].validation.customFunctionMessage = "Invalid " + field.label;
                            // Show validation error at top of form
                            $scope.validationMessages.push(field.alias);
                        }
                    } //Special case for addresses
                    else if (field.alias === "address" || (field.alias === "public_address" && !$scope.user.public_address.same_as_primary)) {
                        // Setup validation result data
                        if (!$scope.fieldsByCode[code].addressValidation) {
                            $scope.fieldsByCode[code].addressValidation = {
                                street_1: {},
                                street_2: {},
                                postal_code: {},
                                municipality: {},
                                county: {}
                            };
                        }

                        // Validate street 1
                        if (value.street_1) {
                            if (!$rootScope.isStringSafe(value.street_1)) {
                                failed = true;
                                $scope.fieldsByCode[code].addressValidation.street_1.customFunctionFailed = true;
                                $scope.fieldsByCode[code].addressValidation.street_1.customFunctionMessage = "Invalid Address";
                                $scope.validationMessages.push(field.name + "_line1");
                            }
                        }
                        // Validate street 2
                        if (value.street_2) {
                            if (!$rootScope.isStringSafe(value.street_2)) {
                                failed = true;
                                $scope.fieldsByCode[code].addressValidation.street_2.customFunctionFailed = true;
                                $scope.fieldsByCode[code].addressValidation.street_2.customFunctionMessage = "Invalid Address";
                                // This is also listed as Address, avoid listing field twice
                                if (!$scope.validationMessages.includes(field.name + "_line2")) {
                                    $scope.validationMessages.push(field.name + "_line2");
                                }
                            }
                        }
                        // Validate postal code
                        if (value.postal_code) {
                            if (!$rootScope.isStringSafe(value.postal_code)) {
                                failed = true;
                                $scope.fieldsByCode[code].addressValidation.postal_code.customFunctionFailed = true;
                                $scope.fieldsByCode[code].addressValidation.postal_code.customFunctionMessage = "Invalid Postal Code";
                                $scope.validationMessages.push(field.name + "_zip");
                            }
                        }
                        // Validate city, mainly applicable to International
                        if(value.municipality) {
                            if (!$rootScope.isStringSafe(value.municipality)) {
                                failed = true;
                                $scope.fieldsByCode[code].addressValidation.municipality.customFunctionFailed = true;
                                $scope.fieldsByCode[code].addressValidation.municipality.customFunctionMessage = "Invalid City";
                                $scope.validationMessages.push(field.name + "_city");
                            }
                        }
                        // Validate county, mainly applicable to International
                        if(value.county) {
                            if (!$rootScope.isStringSafe(value.county)) {
                                failed = true;
                                $scope.fieldsByCode[code].addressValidation.county.customFunctionFailed = true;
                                $scope.fieldsByCode[code].addressValidation.county.customFunctionMessage = "Invalid County";
                                $scope.validationMessages.push(field.name + "_county");
                            }
                        }
                    }
                }
            }

            // Get Login Criteria
            EnterpriseLoginCriteria.get($scope.parameters).then(function (results) {
                if (results != null) {
                    $scope.login_criteria = results;
                }
            });

            // Save user
            if (!failed) {
                if (!$scope.autofill) {
                    delete $scope.user.id;
                }
                Users.save($scope.user, $rootScope.enterpriseID).then(function (result) {
                    if (result != null) {
                        if (result.message != undefined && result.message.length > 0) {
                            if (result.method != undefined && result.method.length > 0) {
                                if (result.method === "warnOnly") {
                                    if ($scope.autofill) {
                                        $state.go('portal.menus.accountDashboard', { messages: [result.message], keepMessages: true });
                                    }
                                    else {
                                        $state.go('portal.menus.login', { messages: [result.message, $scope.login_criteria.account_creation_alert_message], keepMessages: true });
                                    }
                                }
                            }
                            else {
                                // Creation failed for a definite reason (usually duplicate email or username). Should get a message back, and the relevant field to show the error message on.
                                failed = true;
                                if (result.field != undefined && result.field.length > 0) {
                                    if ($scope.fieldsByCode[result.field].validation === undefined || $scope.fieldsByCode[result.field].validation == null) {
                                        $scope.fieldsByCode[result.field].validation = {};
                                    }
                                    $scope.fieldsByCode[result.field].validation.customFunctionFailed = true;
                                    $scope.fieldsByCode[result.field].validation.customFunctionMessage = result.message;
                                    $scope.failedMessages.push(result.message);
                                    $window.scrollTo(0, 0);
                                }
                                else {
                                    // if no field, just display the message at the top of the screen
                                    $scope.failedMessages.push(result.message);
                                    $window.scrollTo(0, 0);
                                }
                            }
                        } else if (result.id !== undefined) {
                            // User object returned
                            if ($scope.autofill) {
                                $state.go('portal.menus.accountDashboard', {});
                            }
                            else {
                                $state.go('portal.menus.login', { messages: [$scope.login_criteria.account_creation_alert_message], keepMessages: true });
                            }
                        }
                    }
                    else {
                        // Something errored
                        $scope.failedMessages.push("There was an error creating your account. Please ensure you have entered all information correctly. If this problem persists, please contact your system administrator.");
                        $window.scrollTo(0, 0);
                    }
                    $scope.saving = false;
                });
            } else {
                $scope.saving = false;
                $window.scrollTo(0, 0);
            }
        }

        $scope.recaptchaSubmit = function () {
            $scope.saving = true; //if there is a loading type var for display
            if ($scope.enterprise.recaptcha_enabled) {
                if ($scope.enterprise.recaptcha_site_key_v3 != null) {
                    grecaptcha.ready(function () {
                        try {
                            grecaptcha.execute($scope.enterprise.recaptcha_site_key_v3, { action: 'publicCreateAccount' }).then(function (token) { //execute returns a token
                                return Enterprise.getRecaptchaResponse("publicCreateAccount", token) // send action, token, score to pass over to server for validation, returns a response object
                            }).then(function (response) { // take the response and update variables
                                if (response.success == false) {
                                    $scope.recaptchaMessage = 'Recaptcha Error: ' + response.error;
                                    $scope.saving = false; //if there is a loading type var for display
                                } else {
                                    $scope.recaptchaMessage = "";
                                };
                            }).then(function () {
                                if ($scope.recaptchaMessage == "") {
                                    $scope.save(); //put function here if passed to continue normal "submit" is recaptcha passed
                                } else {
                                    $scope.$apply(); //update dom so error message displays if recaptcha failed
                                };
                            })
                        } catch (error) {
                            $scope.recaptchaMessage = "There was an issue loading recaptcha, please try again or contact system administrator.";
                            $scope.saving = false; //if there is a loading type var for display
                        }
                    });
                } else {
                    return;
                }
            } else {
                $scope.save(); //put function here to continue normal "submit" if recaptcha is turned off
            };
        };

        $scope.focusQuestion = function (name) {
            var elements = document.getElementsByName(name);
            if (elements && elements[0]) {
                elements[0].scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest"
                });
            }
        };

        $scope.findLabelFromAlias = function (alias) {
            if (alias) {
                //Account for some fields that have mismatching names and aliases, or use hidden aliases for validation instead
                switch (alias) {
                    case 'Address_street1':
                    case 'Address_line1':
                    case 'Address_street2':
                    case 'Address_line2':
                        alias = 'address';
                        break;
                    case 'Public Address_street1':
                    case 'Public Address_line1':
                    case 'Public Address_street2':
                    case 'Public Address_line2':
                        alias = 'public_address';
                        break;
                    case 'Public Address_zip':
                        return 'Postal Code';
                    case 'Address_zip':
                        return 'Postal Code';
                    case 'Address_state':
                        return 'State';
                    case 'Address_city':
                        return 'City';
                    case 'Address_county':
                        return 'County';
                    case 'Public Address_state':
                        return 'State';
                    case 'Public Address_city':
                        return 'City';
                    case 'Public Address_county':
                        return 'County';
                    case 'date':
                        return;
                    case 'slushbox':
                        return;
                    case 'phone':
                        return;
                    case 'driversLicenseNumber':
                        return;
                    case 'dodId':
                        return;
                    case 'input':
                        return;
                    default:
                        break;
                };
                var field = $scope.fieldsByCode[alias];
                if (field) {
                    return field.label || field.name;
                }
                return;
            }
            return;
        };

        $scope.cancel = function () {
            $scope.loading = true;
            $state.go('portal.menus.login', {});
        }

        $scope.numberCheck = function (keyEvent) {
            if (isNaN(keyEvent.key) || keyEvent.key === ' ' || keyEvent.key === '') {
                keyEvent.returnValue = '';
            }
        }

        function fillAutoCompleteForFields(field) {
            const name = field.alias;
            if (name.includes('birth_date')) {
                return 'bday';
            } else if (name.includes('first_name')) {
                return 'given-name';
            } else if (name.includes('last_name')) {
                return 'family-name';
            } else if (name.includes('middle_name')) {
                return 'additional-name';
            } else if (name.includes('occupation_employer')) {
                return 'organization';
            } else if (name.includes('occupation')) {
                return 'organziation-title';
            } else if (name.includes('drivers_license_number') || name.includes('dod_id') || name.includes('prefix') || name.includes('suffix')) {
                return 'off';
            }
        }

    }])
    ;
